import { render, staticRenderFns } from "./HomeInfo.vue?vue&type=template&id=60c8c7ae"
import script from "./HomeInfo.vue?vue&type=script&lang=js"
export * from "./HomeInfo.vue?vue&type=script&lang=js"
import style0 from "./HomeInfo.vue?vue&type=style&index=0&id=60c8c7ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports